/**
 * Alinhamento do widget Lista de Ícones (desktop + mobile).
 * @package gepetto-frontend
 */

const ALIGN_MAP = {
  LEFT: 'flex-start',
  RIGHT: 'flex-end',
  CENTER: 'center',
  NENHUM: 'flex-start',
};

/** Alinhamento efetivo no mobile: vazio/DEFAULT herda o desktop. */
export function resolveListIconMobileAlign(content) {
  const mob = content?.alignMobile;
  if (mob && mob !== 'DEFAULT') return mob;
  return content?.align || 'NENHUM';
}

export function listIconAlignToFlex(align) {
  return ALIGN_MAP[align] || 'flex-start';
}

export function listIconAlignToTextAlign(align) {
  if (align === 'CENTER') return 'center';
  if (align === 'RIGHT') return 'right';
  return 'left';
}

export function listIconRowJustify(align) {
  if (align === 'RIGHT') return 'flex-end';
  if (align === 'CENTER') return 'center';
  return 'flex-start';
}

/** Classe CSS para regras mobile (preview, palco, export). */
export function listIconMobileAlignClass(content) {
  const align = resolveListIconMobileAlign(content);
  if (align === 'CENTER') return 'madri-list-icon-mob-center';
  if (align === 'RIGHT') return 'madri-list-icon-mob-right';
  if (align === 'LEFT') return 'madri-list-icon-mob-left';
  return 'madri-list-icon-mob-start';
}
